import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { getConfigClientFromRTE } from '../../config/config-client';
import { GatekeeperGuard } from '../gatekeeper/gatekeeper.guard';

@Injectable()
export class GatekeeperOnlyForExternalGuard extends GatekeeperGuard {
  override canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const isInternalCrew = getConfigClientFromRTE().isInternal;
    if (isInternalCrew) {
      return of(true);
    }
    return super.canActivate(route);
  }
}
